import type { Prototype } from "../prototype-types";

export const koroshAhangarPrototypes: Prototype[] = [
  {
    id: "video-ad-search",
    name: "Video Ad Search",
    path: "/ka/video-ad-search",
    description:
      "A video ad unit embedded inline within retailer search results, exploring inline and full-width banner placements with auto-play, mute controls, and progress indicators.",
    owner: "Korosh Ahangar",
    createdAt: "2026-04-21",
    lastUpdated: "2026-04-21",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/c52860c1d65769d051136bfada6642115c3cb9bcd64fa9f5450bfca71f9fa27b.png",
    creationTool: "cursor",
  },
  {
    id: "ka-universal-attribution",
    name: "Universal Attribution",
    path: "/ka/universal-attribution",
    description:
      "Unified reporting that counts each order once across ads, email, promotions and leads, with a per-order touchpoint trail",
    owner: "Korosh Ahangar",
    createdAt: "2026-10-08",
    lastUpdated: "2026-10-08",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/ka-universal-attribution.png",
    creationTool: "cursor",
  },
];
